import { RestoreQuizFolderMutation } from '~teacher/hook/useRestoreQuizFolder';

import { reduceUniqueIdsToObject } from '../../../../api/quiz/getQuizzes/normalize/uniqueIds';

interface HandleRestoreSelectedParams {
  selectedQuizItem: Set<string>;
  restoreQuizFolderMutation: RestoreQuizFolderMutation;
}

export function handleRestoreSelected({
  selectedQuizItem,
  restoreQuizFolderMutation: mutate,
}: HandleRestoreSelectedParams) {
  const restoreSelected = () => {
    const { quiz, folder } = reduceUniqueIdsToObject([...selectedQuizItem]);
    mutate({ folderIds: [...folder], quizIds: [...quiz], parentId: null });
  };
  return restoreSelected;
}
